 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","companies~companyCreate~tours~toursList":"companies~companyCreate~tours~toursList","companyCreate":"companyCreate","companies~devices~keys~orders~tablets~tours~toursList~transfers~users":"companies~devices~keys~orders~tablets~tours~toursList~transfers~users","companies":"companies","devices~tablets~tours~toursList":"devices~tablets~tours~toursList","tours":"tours","toursList":"toursList","devices~reports":"devices~reports","devices":"devices","tablets":"tablets","keys":"keys","orders":"orders","transfers":"transfers","users":"users","companyActivate":"companyActivate","crmImport":"crmImport","dashboard":"dashboard","reports":"reports","errorLayout":"errorLayout","lang-de-json":"lang-de-json","lang-el-json":"lang-el-json","lang-fr-json":"lang-fr-json","lang-pl-json":"lang-pl-json","login":"login","profile":"profile","requestPasswordReset":"requestPasswordReset","rootLayout":"rootLayout","settings":"settings","toursImport":"toursImport","user":"user","userActivate":"userActivate","userResetPassword":"userResetPassword","guestLayout~userLayout":"guestLayout~userLayout","userLayout":"userLayout","guestLayout":"guestLayout","profilesLayout":"profilesLayout"}[chunkId]||chunkId) + "." + {"404":"68e9077a","chunk-2d0a3d24":"bdf1cfc0","chunk-2d2228eb":"6a461d78","chunk-2d230495":"0fd31e6e","chunk-2d0afa6b":"b3310989","chunk-2d208ffe":"f7f24ad2","chunk-2d2132d9":"8ee96b44","chunk-2d213f09":"0142e551","companies~companyCreate~tours~toursList":"e5616f9c","companyCreate":"923c3ba2","companies~devices~keys~orders~tablets~tours~toursList~transfers~users":"70ce21ed","companies":"902d1fbf","devices~tablets~tours~toursList":"7e87efba","tours":"16eaf891","toursList":"b9b05396","devices~reports":"e85b3ab4","devices":"e20e5b12","tablets":"803dc639","keys":"deff30bd","orders":"a25856c3","transfers":"abf8d11c","users":"4af73905","companyActivate":"f4b8dff4","crmImport":"e7d220a7","dashboard":"d39ff3ce","reports":"34a1e656","errorLayout":"bf6874e4","lang-de-json":"01d43ee1","lang-el-json":"eb311a72","lang-fr-json":"21dadb56","lang-pl-json":"4bcf599e","login":"e0a62d91","profile":"0e8acc99","requestPasswordReset":"90aa637f","rootLayout":"44b0486f","settings":"4551ecc4","toursImport":"6b26ec7a","user":"5dcbc29b","userActivate":"85776a26","userResetPassword":"528e9618","chunk-13a9cafa":"4c03321f","chunk-2d0cfa96":"93547f63","chunk-59c9bf98":"586c173d","chunk-2d224d20":"99e18481","guestLayout~userLayout":"99963e1e","userLayout":"26f2a47b","guestLayout":"960a8317","profilesLayout":"febd0715","chunk-2d0e9baf":"eff426df"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"companyCreate":1,"companies~devices~keys~orders~tablets~tours~toursList~transfers~users":1,"companies":1,"devices~tablets~tours~toursList":1,"tours":1,"toursList":1,"devices~reports":1,"devices":1,"tablets":1,"orders":1,"users":1,"crmImport":1,"dashboard":1,"reports":1,"toursImport":1,"chunk-13a9cafa":1,"chunk-59c9bf98":1,"guestLayout~userLayout":1,"userLayout":1,"profilesLayout":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","companies~companyCreate~tours~toursList":"companies~companyCreate~tours~toursList","companyCreate":"companyCreate","companies~devices~keys~orders~tablets~tours~toursList~transfers~users":"companies~devices~keys~orders~tablets~tours~toursList~transfers~users","companies":"companies","devices~tablets~tours~toursList":"devices~tablets~tours~toursList","tours":"tours","toursList":"toursList","devices~reports":"devices~reports","devices":"devices","tablets":"tablets","keys":"keys","orders":"orders","transfers":"transfers","users":"users","companyActivate":"companyActivate","crmImport":"crmImport","dashboard":"dashboard","reports":"reports","errorLayout":"errorLayout","lang-de-json":"lang-de-json","lang-el-json":"lang-el-json","lang-fr-json":"lang-fr-json","lang-pl-json":"lang-pl-json","login":"login","profile":"profile","requestPasswordReset":"requestPasswordReset","rootLayout":"rootLayout","settings":"settings","toursImport":"toursImport","user":"user","userActivate":"userActivate","userResetPassword":"userResetPassword","guestLayout~userLayout":"guestLayout~userLayout","userLayout":"userLayout","guestLayout":"guestLayout","profilesLayout":"profilesLayout"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","chunk-2d0a3d24":"31d6cfe0","chunk-2d2228eb":"31d6cfe0","chunk-2d230495":"31d6cfe0","chunk-2d0afa6b":"31d6cfe0","chunk-2d208ffe":"31d6cfe0","chunk-2d2132d9":"31d6cfe0","chunk-2d213f09":"31d6cfe0","companies~companyCreate~tours~toursList":"31d6cfe0","companyCreate":"ff3ba749","companies~devices~keys~orders~tablets~tours~toursList~transfers~users":"ced29771","companies":"55d64ce0","devices~tablets~tours~toursList":"2819fc7e","tours":"34a063a6","toursList":"dfe5282d","devices~reports":"fc6e80af","devices":"4889a038","tablets":"13467fcd","keys":"31d6cfe0","orders":"ff3ba749","transfers":"31d6cfe0","users":"025ecc87","companyActivate":"31d6cfe0","crmImport":"c398f970","dashboard":"6addec3b","reports":"48edf778","errorLayout":"31d6cfe0","lang-de-json":"31d6cfe0","lang-el-json":"31d6cfe0","lang-fr-json":"31d6cfe0","lang-pl-json":"31d6cfe0","login":"31d6cfe0","profile":"31d6cfe0","requestPasswordReset":"31d6cfe0","rootLayout":"31d6cfe0","settings":"31d6cfe0","toursImport":"75427421","user":"31d6cfe0","userActivate":"31d6cfe0","userResetPassword":"31d6cfe0","chunk-13a9cafa":"51f50bfc","chunk-2d0cfa96":"31d6cfe0","chunk-59c9bf98":"e4c9f42c","chunk-2d224d20":"31d6cfe0","guestLayout~userLayout":"1a39de5a","userLayout":"585ae30a","guestLayout":"31d6cfe0","profilesLayout":"cc59a781","chunk-2d0e9baf":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
